var $09e991522ca7e64e$exports = {};
/* eslint-disable no-undef */ "use strict";
const $09e991522ca7e64e$var$COLUMNS_NUMBER = 4;
const $09e991522ca7e64e$var$ROWS_NUMBER = 4;
let $09e991522ca7e64e$var$board;
let $09e991522ca7e64e$var$score = 0;
let $09e991522ca7e64e$var$scoreBestItem = localStorage.getItem("scoreBest!!!") || 0;
const $09e991522ca7e64e$var$startButton = document.querySelector(".start");
const $09e991522ca7e64e$var$restartButton = document.querySelector(".restart");
const $09e991522ca7e64e$var$scoreItem = document.querySelector(".game-score");
const $09e991522ca7e64e$var$bestScoreItem = document.querySelector(".game-score-best");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
$09e991522ca7e64e$var$startButton.addEventListener("click", $09e991522ca7e64e$var$startGame);
$09e991522ca7e64e$var$restartButton.addEventListener("click", $09e991522ca7e64e$var$resetGame);
function $09e991522ca7e64e$var$startGame() {
    $09e991522ca7e64e$var$setGame();
    $09e991522ca7e64e$var$startButton.classList.add("hidden");
    $09e991522ca7e64e$var$restartButton.classList.remove("hidden");
    $09e991522ca7e64e$var$messageStart.classList.add("hidden");
    $09e991522ca7e64e$var$bestScoreItem.innerText = $09e991522ca7e64e$var$scoreBestItem;
}
function $09e991522ca7e64e$var$resetGame() {
    $09e991522ca7e64e$var$resetBoard();
    $09e991522ca7e64e$var$resetScore();
    $09e991522ca7e64e$var$startButton.classList.remove("hidden");
    $09e991522ca7e64e$var$restartButton.classList.add("hidden");
    $09e991522ca7e64e$var$messageStart.classList.remove("hidden");
    $09e991522ca7e64e$var$messageLose.classList.add("hidden");
    $09e991522ca7e64e$var$messageWin.classList.add("hidden");
    $09e991522ca7e64e$var$bestScoreItem.innerText = $09e991522ca7e64e$var$scoreBestItem;
}
function $09e991522ca7e64e$var$initializeBoard() {
    return Array.from({
        length: $09e991522ca7e64e$var$ROWS_NUMBER
    }, ()=>Array($09e991522ca7e64e$var$COLUMNS_NUMBER).fill(0));
}
function $09e991522ca7e64e$var$setGame() {
    $09e991522ca7e64e$var$board = $09e991522ca7e64e$var$initializeBoard();
    for(let i = 0; i < $09e991522ca7e64e$var$ROWS_NUMBER; i++)for(let j = 0; j < $09e991522ca7e64e$var$COLUMNS_NUMBER; j++){
        const fieldCell = document.createElement("div");
        fieldCell.id = i.toString() + "-" + j.toString();
        const num = $09e991522ca7e64e$var$board[i][j];
        $09e991522ca7e64e$var$updateTile(fieldCell, num);
        document.querySelector(".game-field").append(fieldCell);
    }
    $09e991522ca7e64e$var$setNewElement();
    $09e991522ca7e64e$var$setNewElement();
}
function $09e991522ca7e64e$var$updateTile(fieldCell, num) {
    fieldCell.innerText = "";
    fieldCell.classList.value = "";
    fieldCell.classList.add("field-cell");
    if (num > 0) {
        fieldCell.innerText = num.toString();
        fieldCell.classList.add("field-cell--" + num.toString());
    }
    $09e991522ca7e64e$var$gameWin();
}
function $09e991522ca7e64e$var$resetScore() {
    $09e991522ca7e64e$var$score = 0;
    $09e991522ca7e64e$var$scoreItem.innerText = $09e991522ca7e64e$var$score;
}
function $09e991522ca7e64e$var$resetBoard() {
    const currentBoard = document.querySelector(".game-field");
    currentBoard.innerHTML = "";
}
function $09e991522ca7e64e$var$hasEmptyTile() {
    for(let i = 0; i < $09e991522ca7e64e$var$ROWS_NUMBER; i++)for(let j = 0; j < $09e991522ca7e64e$var$COLUMNS_NUMBER; j++){
        if ($09e991522ca7e64e$var$board[i][j] === 0) return true;
    }
    return false;
}
function $09e991522ca7e64e$var$setNewElement() {
    let found = false;
    if (!$09e991522ca7e64e$var$hasEmptyTile()) return;
    while(!found){
        const i = Math.floor(Math.random() * $09e991522ca7e64e$var$ROWS_NUMBER);
        const j = Math.floor(Math.random() * $09e991522ca7e64e$var$COLUMNS_NUMBER);
        if ($09e991522ca7e64e$var$board[i][j] === 0) {
            const randomNum = Math.floor(Math.random() * 10);
            if (randomNum === 0) $09e991522ca7e64e$var$board[i][j] = 4;
            else $09e991522ca7e64e$var$board[i][j] = 2;
            const fieldCell = document.getElementById(i.toString() + "-" + j.toString());
            fieldCell.innerText = $09e991522ca7e64e$var$board[i][j].toString();
            fieldCell.classList.add("field-cell--" + $09e991522ca7e64e$var$board[i][j]);
            found = true;
        }
    }
    if ($09e991522ca7e64e$var$gameOver()) $09e991522ca7e64e$var$messageLose.classList.remove("hidden");
}
document.addEventListener("keyup", (e)=>{
    let boardChanged = false;
    switch(e.code){
        case "ArrowLeft":
            boardChanged = $09e991522ca7e64e$var$slideLeft();
            break;
        case "ArrowRight":
            boardChanged = $09e991522ca7e64e$var$slideRight();
            break;
        case "ArrowUp":
            boardChanged = $09e991522ca7e64e$var$slideUp();
            break;
        case "ArrowDown":
            boardChanged = $09e991522ca7e64e$var$slideDown();
            break;
        default:
            alert("Please, use only arrows!");
    }
    if (boardChanged) {
        $09e991522ca7e64e$var$setNewElement();
        $09e991522ca7e64e$var$scoreItem.innerText = $09e991522ca7e64e$var$score;
        if ($09e991522ca7e64e$var$score >= $09e991522ca7e64e$var$scoreBestItem) {
            $09e991522ca7e64e$var$scoreBestItem = $09e991522ca7e64e$var$score;
            $09e991522ca7e64e$var$bestScoreItem.innerText = $09e991522ca7e64e$var$score;
            localStorage.setItem("scoreBest!!!", $09e991522ca7e64e$var$scoreBestItem);
        }
    }
});
function $09e991522ca7e64e$var$deleteZero(row) {
    return row.filter((num)=>num !== 0);
}
function $09e991522ca7e64e$var$slide(originalRow) {
    let newRow = [
        ...originalRow
    ];
    newRow = $09e991522ca7e64e$var$deleteZero(newRow);
    for(let i = 0; i < newRow.length - 1; i++)if (newRow[i] === newRow[i + 1]) {
        newRow[i] *= 2;
        newRow[i + 1] = 0;
        $09e991522ca7e64e$var$score += newRow[i];
    }
    newRow = $09e991522ca7e64e$var$deleteZero(newRow);
    while(newRow.length < $09e991522ca7e64e$var$COLUMNS_NUMBER)newRow.push(0);
    return newRow;
}
function $09e991522ca7e64e$var$slideLeft() {
    let boardChanged = false;
    for(let i = 0; i < $09e991522ca7e64e$var$ROWS_NUMBER; i++){
        let row = $09e991522ca7e64e$var$board[i];
        const originalRow = [
            ...row
        ];
        row = $09e991522ca7e64e$var$slide(row);
        $09e991522ca7e64e$var$board[i] = row;
        if (!boardChanged && !originalRow.every((val, index)=>val === row[index])) boardChanged = true;
        for(let j = 0; j < $09e991522ca7e64e$var$COLUMNS_NUMBER; j++){
            const fieldCell = document.getElementById(i.toString() + "-" + j.toString());
            const num = $09e991522ca7e64e$var$board[i][j];
            $09e991522ca7e64e$var$updateTile(fieldCell, num);
        }
    }
    return boardChanged;
}
function $09e991522ca7e64e$var$slideRight() {
    let boardChanged = false;
    for(let i = 0; i < $09e991522ca7e64e$var$ROWS_NUMBER; i++){
        let row = $09e991522ca7e64e$var$board[i];
        const originalRow = [
            ...row
        ];
        row.reverse();
        row = $09e991522ca7e64e$var$slide(row);
        row.reverse();
        $09e991522ca7e64e$var$board[i] = row;
        if (!boardChanged && !originalRow.every((val, index)=>val === row[index])) boardChanged = true;
        for(let j = 0; j < $09e991522ca7e64e$var$COLUMNS_NUMBER; j++){
            const fieldCell = document.getElementById(i.toString() + "-" + j.toString());
            const num = $09e991522ca7e64e$var$board[i][j];
            $09e991522ca7e64e$var$updateTile(fieldCell, num);
        }
    }
    return boardChanged;
}
function $09e991522ca7e64e$var$slideUp() {
    let boardChanged = false;
    for(let j = 0; j < $09e991522ca7e64e$var$COLUMNS_NUMBER; j++){
        let row = [
            $09e991522ca7e64e$var$board[0][j],
            $09e991522ca7e64e$var$board[1][j],
            $09e991522ca7e64e$var$board[2][j],
            $09e991522ca7e64e$var$board[3][j]
        ];
        const originalRow = [
            ...row
        ];
        row = $09e991522ca7e64e$var$slide(row);
        if (!boardChanged && !originalRow.every((val, index)=>val === row[index])) boardChanged = true;
        for(let i = 0; i < $09e991522ca7e64e$var$ROWS_NUMBER; i++){
            $09e991522ca7e64e$var$board[i][j] = row[i];
            const fieldCell = document.getElementById(i.toString() + "-" + j.toString());
            const num = $09e991522ca7e64e$var$board[i][j];
            $09e991522ca7e64e$var$updateTile(fieldCell, num);
        }
    }
    return boardChanged;
}
function $09e991522ca7e64e$var$slideDown() {
    let boardChanged = false;
    for(let j = 0; j < $09e991522ca7e64e$var$COLUMNS_NUMBER; j++){
        let row = [
            $09e991522ca7e64e$var$board[0][j],
            $09e991522ca7e64e$var$board[1][j],
            $09e991522ca7e64e$var$board[2][j],
            $09e991522ca7e64e$var$board[3][j]
        ];
        const originalRow = [
            ...row
        ];
        row.reverse();
        row = $09e991522ca7e64e$var$slide(row);
        row.reverse();
        if (!boardChanged && !originalRow.every((val, index)=>val === row[index])) boardChanged = true;
        for(let i = 0; i < $09e991522ca7e64e$var$ROWS_NUMBER; i++){
            $09e991522ca7e64e$var$board[i][j] = row[i];
            const fieldCell = document.getElementById(i.toString() + "-" + j.toString());
            const num = $09e991522ca7e64e$var$board[i][j];
            $09e991522ca7e64e$var$updateTile(fieldCell, num);
        }
    }
    return boardChanged;
}
function $09e991522ca7e64e$var$gameOver() {
    if ($09e991522ca7e64e$var$hasEmptyTile()) return false;
    for(let i = 0; i < $09e991522ca7e64e$var$ROWS_NUMBER; i++)for(let j = 0; j < $09e991522ca7e64e$var$COLUMNS_NUMBER - 1; j++){
        if ($09e991522ca7e64e$var$board[i][j] === $09e991522ca7e64e$var$board[i][j + 1] || $09e991522ca7e64e$var$board[j][i] === $09e991522ca7e64e$var$board[j + 1][i]) return false;
    }
    return true;
}
function $09e991522ca7e64e$var$gameWin() {
    for(let i = 0; i < $09e991522ca7e64e$var$ROWS_NUMBER; i++){
        for(let j = 0; j < $09e991522ca7e64e$var$COLUMNS_NUMBER; j++)if ($09e991522ca7e64e$var$board[i][j] === 2048) {
            $09e991522ca7e64e$var$messageWin.classList.remove("hidden");
            return true;
        }
    }
    return false;
}


//# sourceMappingURL=index.4da3c325.js.map
